var React = require('react');

function CloseModal (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.75736 7.75729L16.2426 16.2426M16.2426 7.75729L7.75736 16.2426","stroke":"#0A2240","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

CloseModal.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = CloseModal;

CloseModal.default = CloseModal;
